import { Button } from "react-bootstrap";
import "../../styles/MemberProfile.css";

const ProfileCard = ({
  title,
  isEditing,
  onEdit,
  onSave,
  onCancel,
  hideActions = false,
  children,
}) => {
  const formId = title.replace(/\s+/g, "-").toLowerCase() + "-form";

  const handleSubmit = (e) => {
    e.preventDefault();
    if (isEditing) onSave();
  };

  return (
    <div className="profile-card-container">
      <div className="profile-card-header">
        <h3 className="profile-card-title">{title}</h3>

        {!hideActions && (
          <>
            {!isEditing ? (
              <button
                className="link-button edit-top-btn text-primary"
                onClick={onEdit}
              >
                Edit
              </button>
            ) : (
              <div className="d-flex gap-2">
                <Button size="sm" variant="primary" type="submit" form={formId}>
                  Save
                </Button>

                <Button size="sm" variant="secondary" onClick={onCancel}>
                  Cancel
                </Button>
              </div>
            )}
          </>
        )}
      </div>

      <form id={formId} onSubmit={handleSubmit}>
        <div className="profile-card-content">{children}</div>
      </form>
    </div>
  );
};

export default ProfileCard;
